import { render, staticRenderFns } from "./targetsalesfull.vue?vue&type=template&id=8a554f02&scoped=true"
import script from "./targetsalesfull.vue?vue&type=script&lang=js"
export * from "./targetsalesfull.vue?vue&type=script&lang=js"
import style0 from "./targetsalesfull.vue?vue&type=style&index=0&id=8a554f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a554f02",
  null
  
)

export default component.exports